import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import {
	getFirestore,
	connectFirestoreEmulator,
	doc,
	setDoc,
	getDoc,
} from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";

const firebaseConfig = {
	apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
	authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
	projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
	storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
	messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
	appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

auth.settings = {
	appVerificationDisabledForTesting: import.meta.env.DEV, // Only for development
};

const useEmulator =
	import.meta.env.VITE_FIREBASE_USE_EMULATOR === "false" && import.meta.env.DEV;

if (useEmulator) {
	connectAuthEmulator(auth, "http://localhost:9099", {
		disableWarnings: true, // Disable JWT warnings
	});
	connectFirestoreEmulator(db, "localhost", 8080);
	connectStorageEmulator(storage, "localhost", 9199);
	console.log("Using Firebase Emulators");
}

if (!useEmulator) {
	storage.maxOperationRetryTime = 10000;
	storage.maxUploadRetryTime = 10000;
}

export const initializeStatistics = async () => {
	const statsRef = doc(db, "statistics", "downloads");

	try {
		// Check if document exists first
		const docSnap = await getDoc(statsRef);

		if (!docSnap.exists()) {
			// Create initial document if it doesn't exist
			await setDoc(statsRef, {
				foodMapDownloads: 0,
				lastDownloadAt: null,
				ebookDownloads: 0,
				lastEbookDownloadAt: null,
			});
			console.log("Statistics document initialized");
		}
	} catch (error) {
		console.error("Error initializing statistics:", error);
	}
};

// Call initialization
initializeStatistics().catch(console.error);

export { auth, db, storage };
